// extracted by mini-css-extract-plugin
export var title = "pageTitle-module--title--23Ic+";